// extracted by mini-css-extract-plugin
export default {"container":"ChangeLanguage_container__4I3Oy","contentBox":"ChangeLanguage_contentBox__nfeeH"};